const h5pResultsObjects = document.querySelectorAll('.h5pAnswers__wrapper');

if (h5pResultsObjects.length > 0) {
    [...h5pResultsObjects].forEach(cell => {
        cell.addEventListener('click', event => {
            let switcher = (cell.dataset.open == "true");
            cell.dataset.open = !switcher;
        });
    })
}